module.exports = __webpack_public_path__ + "static/assets/7e49b0753b9ee3060d8d9f26a183a9bd.svg";